<template>
    <div id="dvregulariza">
        <div class="container-fluid" style="height: 100%;">
            <div class="row" style="height: 100%;">   
                <h1>Regularizar Sistema!</h1>
            </div>
        </div>    
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
  name: "regulariza",
  data: function() {
    return {     
    };
  },
  methods:{
  },
  mounted: function () {          
  },
  computed:{    
  },
  watch:{
  }    
}
</script>
<style>
</style>